module.exports = __webpack_public_path__ + "img/图像20.ebb59359.png";